import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import styles from "./AddReportModal.module.scss";
import Modal from "components/Modal/Modal";
import FormElement from "components/FormElement/FormElement";
import DateInput from "components/DateInput/DateInput"
import Select from "components/Select/Select";
import Button from "components/Button/Button";
// import Checkbox from "components/Checkbox/Checkbox";

import {
    loadSitesAction,
    createReportAction,
    loadAuditsAction,
    loadDeptAction,
} from "store/actions/Actions";
import { toggleDropdowns } from "helpers/utils";

const AddReportModal = props => {

    const [state, setState] = useState({
        site: "",
        report: "",
        audit: "",
        selected_report: {},
        selected_site: {},
        selected_audit: {},
        selected_dep: {
            id: false,
            name: 'All'
        },
        selected_inactive: {
            id: "false",
            name: 'Exclude inactive users'
        },
        selected_attestation: {
            id: "undefined",
            name: 'All'
        },
        inactive_users: true,
        attestation_status: false,
        unfinished: false,
        date_from: "",
        date_to: "",
    });

    const [stateErrors, setStateErrors] = useState({
        site: "",
        report: "",
        audit: "",
        selected_report: {},
        selected_audit: {},
        selected_site: {},
        date_from: "",
        date_to: "",
    });

    const { SitesReducer, AuditsReducer, UserOrgSiteReducer, DepartmentsReducer, loadSitesAction, loadDeptAction, loadAuditsAction, createReportAction } = props;

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!AuditsReducer.audits) {
            loadAuditsAction();
        }
    }, [loadAuditsAction, AuditsReducer.audits]);

    const handleReportChange = e => {
        setState({
            ...state,
            report: e.target.dataset.name,
            selected_report: {
                type: e.target.dataset.type,
                name: e.target.dataset.name
            },
            selected_site: {},
            selected_audit: {},
        });
        setStateErrors({
            ...stateErrors,
            report: ""
        });
    }

    const handleSiteChange = e => {
        let site_id = undefined;
        if (e.target.value === -1) {
            site_id = undefined;
        }
        if (e.target.value === 0) {
            site_id = false;
        }
        if (e.target.value > 0) {
            site_id = e.target.value;
        }
        loadDeptAction({ site: e.target.value });
        setState({
            ...state,
            site: e.target.dataset.name,
            selected_site: {
                id: site_id,
                name: e.target.dataset.name
            },
            selected_audit: {},
        });
        setStateErrors({
            ...stateErrors,
            site: ""
        });
    }

    const handleDepChange = e => {
        setState((s) => ({
            ...s,
            userId: "0",
            selected_dep: {
                id: e.target.value,
                name: e.target.dataset.name
            }
        }));

        setStateErrors({
            ...stateErrors,
            dep: ""
        });
    }

    const handleFilterInactiveChange = (e) => {
        setState((s) => ({
            ...s,
            selected_inactive: { id: e.target.dataset.value, name: e.target.dataset.name },
        }));
    }

    const handleFilterAttestationChange = (e) => {
        setState((s) => ({
            ...s,
            selected_attestation: { id: e.target.dataset.value, name: e.target.dataset.name },
        }));
    }

    const handleAuditChange = e => {
        setState({
            ...state,
            audit: e.target.dataset.name,
            selected_audit: {
                id: e.target.value,
                name: e.target.dataset.name
            }
        });
        setStateErrors({
            ...stateErrors,
            audit: ""
        });
    }

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const addReport = async (e) => {
        if (((state.site === "" || state.report === "") || (state.selected_report.type === 'attestation' && (state.date_from === "" || state.date_to === "")) || (state.selected_report.type === 'risk' && state.audit === '')) && state.selected_report.type !== "task") {
            setStateErrors({
                ...stateErrors,
                audit: state.audit === "" ? "Audit is required" : "",
                site: state.site === "" ? "Site is required" : "",
                report: state.report === "" ? "Report is required" : "",
                date_from: state.date_from === "" ? "Date from is required" : "",
                date_to: state.date_to === "" ? "Date to is required" : "",
            });
        } else {
            await createReportAction(
                {
                    audit: state.selected_audit.id,
                    site: state.selected_site.id,
                    department: state.selected_dep.id,
                    type: state.selected_report.type,
                    name: state.selected_report.type != 'risk' ? state.selected_report.name : `${state.selected_report.name} - ${state.selected_audit.name}`,
                    date_from: state.date_from,
                    date_to: state.date_to,
                    filter: {
                        inactive_users: state.selected_inactive.id === "true" ? true : false,
                        attestation_status: state.selected_attestation.id === "undefined" ? undefined : (state.selected_attestation.id === "true" ? true : false),
                    },
                }
            );
            props.setShowModal(false);
        }
    }

    const reportDropdownRef = useRef();
    const siteDropdownRef = useRef();
    const auditDropdownRef = useRef();
    const depDropdownRef = useRef();
    const f1DropdownRef = useRef();
    const f2DropdownRef = useRef();

    const is_site_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_site_admin) || false;

    return (
        <Modal
            className={styles.modal}
            setShowModal={props.setShowModal}
        >
            <div onClick={toggleDropdowns([
                reportDropdownRef,
                siteDropdownRef,
                auditDropdownRef,
                depDropdownRef,
                f1DropdownRef,
                f2DropdownRef,
            ])}>
                <p className={styles["modal-heading"]}>Add Report</p>

                <div className={styles["modal-content"]}>

                    <FormElement
                        labelText="REPORT NAME"
                        htmlFor="report"
                        errorMessage={stateErrors.report}
                    >
                        <Select
                            value={state.selected_report.name}
                            placeholder="Select Report"
                            onClick={handleReportChange}
                            dropdownToggleRef={reportDropdownRef}
                        >
                            {props.reportsList.map(report => {
                                    if (report.isOrgWide && is_site_admin) {
                                        return false;
                                    }
                                    return <li key={`reportid-${report.key}`} data-name={report.name} data-type={report.type} value={report.name}>{report.name}</li>
                                }
                            )}

                        </Select>
                    </FormElement>

                    {state.selected_report.type === 'attestation' ? <div>

                        <div className={styles.dates_holder}>
                            <FormElement
                                className={styles.department}
                                labelText="USERS STATUS"
                                htmlFor="inactive_users"
                            >
                                <Select
                                    name="inactive_users"
                                    value={state.selected_inactive.name}
                                    placeholder=""
                                    onClick={handleFilterInactiveChange}
                                    dropdownToggleRef={f1DropdownRef}
                                >
                                    <li key={`depid-exclude`} value={false} data-value="false" data-name={'Exclude inactive users'}>Exclude inactive users</li>
                                    <li key={`depid-include`} value={true} data-value="true" data-name={'Include inactive users'}>Include inactive users</li>
                                </Select>
                            </FormElement>
                            <FormElement
                                className={styles.department}
                                labelText="ATTESTATION STATUS"
                                htmlFor="attestation_status"
                            >
                                <Select
                                    name="attestation_status"
                                    value={state.selected_attestation.name}
                                    placeholder=""
                                    onClick={handleFilterAttestationChange}
                                    dropdownToggleRef={f2DropdownRef}
                                >
                                    <li key={`depid-all`} value={undefined} data-value="undefined" data-name={'All'}>All</li>
                                    <li key={`depid-completed`} value={true} data-value="true" data-name={'Only completed'}>Only completed</li>
                                    <li key={`depid-incompleted`} value={false} data-value="false" data-name={'Only incompleted'}>Only incompleted</li>
                                </Select>
                            </FormElement>
                        </div>

                    </div> : ""}

                    {state.selected_report.type !== 'task' &&
                    <>
                    
                    <FormElement
                        labelText="SITE"
                        htmlFor="site"
                        errorMessage={stateErrors.site}
                    >
                        <Select
                            value={state.selected_site.name}
                            placeholder="Select Site"
                            onClick={handleSiteChange}
                            dropdownToggleRef={siteDropdownRef}
                        >

                            {is_site_admin ? "" :
                            (state.selected_report.type === 'gap' || state.selected_report.type === 'remediation' || state.selected_report.type === 'attestation' || state.selected_report.type === 'vendor') &&
                                <li key={`siteid-orgwide`} data-name={'Org Wide Trainings'} value={-1}>Org Wide Trainings</li>
                            }

                            {is_site_admin ? "" :
                            state.selected_report.type === 'risk'
                                ?
                                <li key={`siteid-all`} data-name={'Org Wide Trainings'} value={-1}>Org Wide Trainings</li>
                                :
                                <li key={`siteid-all`} data-name={'All'} value={false}>All</li>
                            }
                            {SitesReducer.sites.map(site => <li key={`siteid-${site.id}`} data-name={site.name} value={site.id}>{site.name}</li>)}
                        </Select>
                    </FormElement>

                    </>
                    }

                    {state.selected_report.type === 'attestation' &&
                    <>
                        <FormElement
                            className={styles.department}
                            labelText="DEPARTMENT"
                            htmlFor="department"
                            // errorMessage={stateErrors.site}
                        >
                            <Select
                                value={state.selected_dep.name}
                                placeholder="Select Department"
                                onClick={handleDepChange}
                                dropdownToggleRef={depDropdownRef}
                            >
                                <li key={`depid-all`} data-name={'All'} value={"0"}>All</li>
                                {DepartmentsReducer && DepartmentsReducer.departments && DepartmentsReducer.departments.filter((dep) => dep.active === "t").map(department => <li key={`siteid-${department.id}`} data-name={department.name} value={department.id}>{department.name}</li>)}
                            </Select>
                        </FormElement>
                    </>
                    }

                    {state.selected_report.type === 'risk' &&
                        <>
                        <FormElement
                            labelText="AUDIT"
                            htmlFor="audit"
                            errorMessage={stateErrors.audit}
                        >
                            <Select
                                value={state.selected_audit.name}
                                placeholder="Select Audit"
                                onClick={handleAuditChange}
                                dropdownToggleRef={auditDropdownRef}
                            >
                                {AuditsReducer.audits && AuditsReducer.audits
                                    .filter((audit) => !audit.name.includes("Device"))
                                    .filter((audit) => state.selected_site.id ? audit.site === `${state.selected_site.id}` : audit.site === "")
                                    .map(audit => <li key={`auditid-${audit.id}`} data-name={audit.name} value={audit.id}>{audit.name}</li>)}

                            </Select>
                        </FormElement>

                        </>
                        
                    }

                    {state.selected_report.type === 'attestation' ? <div className={styles.dates_holder}>
                        <FormElement
                            labelText="FROM DATE"
                            htmlFor="date_from"
                            errorMessage={stateErrors["date_from"]}
                        >
                            <DateInput
                                onChange={handleChange('date_from')}
                                value={state["date_from"]}
                            />
                        </FormElement>
                        <FormElement
                            labelText="TO DATE"
                            htmlFor="date_to"
                            errorMessage={stateErrors["date_to"]}
                        >
                            <DateInput
                                onChange={handleChange('date_to')}
                                value={state["date_to"]}
                            />
                        </FormElement>
                    </div> : ""}
                </div>

                <div className={styles["modal-footer"]}>
                    <Button
                        text="CANCEL"
                        color="secondary"
                        onClick={() => props.setShowModal(false)}
                    />
                    <Button
                        text="ADD REPORT"
                        className={styles.create}
                        onClick={addReport}
                    />
                </div>

            </div>
        </Modal>
    );
};

const mapStateToProps = ({
    ActsReducer,
    AuditsReducer,
    DepartmentsReducer,
    SitesReducer,
    UserOrgSiteReducer,
}) => ({
    ActsReducer,
    AuditsReducer,
    DepartmentsReducer,
    SitesReducer,
    UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadAuditsAction,
    loadDeptAction,
    createReportAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddReportModal);
